import React from 'react';
import styles from '../TripTrackingV2.module.scss';

const InfoCard = ({ title, children }) => (
  <section className={styles.card}>
    <div className={styles.cardTitle}>{title}</div>
    {children}
  </section>
);

export default InfoCard;
